import global$1 from './global.js';
import objectIsPrototypeOf from './object-is-prototype-of.js';

var global = global$1;
var isPrototypeOf = objectIsPrototypeOf;
var TypeError = global.TypeError;

var anInstance = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw TypeError('Incorrect invocation');
};

export { anInstance as default };
